<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-9" xl="9">
                        <div class="font-weight-bold body-1">
                            Nueva Venta
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="9" xl="9">
                        <v-form ref="form" @submit.prevent="save">
                            <ar-form :key="componentKey" ref="ReceivableAccount" :values="form" @save="save" :serverErrors="serverErrors"></ar-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="9" xl="9" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../helpers/Utils';
import ReceivableAccount from "./FormReceivableAccount.vue";


export default {
    components: {
        'ar-form': ReceivableAccount,
    },
	data(){
		return {
            id: this.$route.params.id,
            componentKey: 0,
            loading: false,
            serverErrors: {},
            form: {
                type: "",//other posible values: NORMAL, ANTICIPADA, COTIZACIÓN, SERVICIOS, CONTADO, CRÉDITO
                credit_period: "",//
                concept_id: "",
                comments: "",


                //readonly
                receiver_id: '',
                date: '',
                reference_id:'',
                currency:'',
                items:[],
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "SaleBills",
                block:false,
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        this.index();
    },
	methods: {
        index(){
            this.loading = true;
            this.$store.state.loading = true;
            this.$api.saleBill.get(this.$store.state.business, this.id)
                .then((resp) => {
                    this.form.receiver_id = resp.data?.customer?.slug??';'
                    this.form.currency =  resp.data?.currency??'';
                    this.form.date =  resp.data?.date??'';
                    this.form.reference_id = resp.data?.reference?.slug??'';
                    this.form.items = resp.data.items;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },
		validate () {
            //console.log(this.serverErrors);
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
           
          
            // this.forceRerender();
			return this.$refs.form.validate();
            // return true;
		},
        forceRerender() {
            this.componentKey += 1;
        },
         onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
        save(){
            
            console.log(this.form);
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                //console.log(form);
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.saleBill.storeReceivableAccount(this.$store.state.business,this.id, form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha creado correctamente`);
                        this.$router.push({name: 'SaleBills'});
                    })
                    .catch((error) => {
                        //console.log(error.response)
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                //console.log(99, error.response);
                                if(("error" in error.response.data)){
                                    console.log(error.response.data.error)
                                    if(typeof error.response.data.error === 'string'){
                                        this.$store.dispatch('snackbarError', error.response.data.error);
                                        return;
                                    }
                                    Object.keys(error.response.data.error).forEach((x) => {
                                        //console.log(x);
                                        this.serverErrors = error.response.data.error;
                                        error.response.data.error[x].forEach((y) => {
                                            this.serverErrors[x] = Utils.deleteWord(x,y);
                                            errors.push(Utils.deleteWord(x,y))
                                        })
                                    });
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }

                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },
        prepareRequest(request)
        {
            let data = JSON.parse(JSON.stringify(request));

            delete data.currency;
            delete data.date;
            delete data.receiver_id;
            delete data.reference_id;
            delete data.items;
            
            
            return data;
        }
    },
}
</script>

<style>

</style>